
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

if (process.client) {
  gsap.registerPlugin(ScrollTrigger)
}
export default {
  props: { content: { type: Object, required: true, default: () => {} }, postTitle: { type: String, required: true, default: '' } },
  data () {
    return {
      animation: null
    }
  },
  mounted () {
    const _this = this
    gsap.utils.toArray(['.text p strong', '.text ul li strong']).forEach(function (elem) {
      _this.animation = gsap.timeline({
        scrollTrigger: {
          trigger: elem,
          start: 'top 70%',
          end: 'bottom 10%',
          // markers: true,
          toggleActions: 'restart pause resume none',
          onLeaveBack: self => self.disable()
        }
      })
      _this.animation.to(elem, 0.8, { backgroundSize: '100% 40%' })
    })
  },
  beforeDestroy () {
    ScrollTrigger.getAll().forEach(t => t.kill())
  },
  methods: {
    // splitUrl (url) {
    //   let tmp = (url !== null) ? url : false
    //   if (tmp) {
    //     const split = tmp.split('https://dna.studio375.it/wp-content')
    //     tmp = split[1]
    //   }
    //   return tmp
    // }
  }
}
